/**
 * Created by hj on 2017/8/24.
 */
import React from 'react';
import {Button, message} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {objectSerial, config} from 'Utils';
import {getSalesQueryList} from '../../service/financialMgm';

class SalesQueryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['销售查询（收款类型）'],
            showHideBtnIndex: 0,
            key: 0,
            filterBoxVisible: false,
            rows: [
                // {
                //   id: 1,
                //   /*name: '浙江电工张华',
                //   type: '现金',*/
                //   cusName: '浙江电工张华',
                //   payType: '现金',
                //   amount: '500000'
                // },
                // {
                //   id: 2,
                //   cusName: '浙江电工张华',
                //   payType: '欠款',
                //   amount: '250000'
                // }
            ],
            total: 1,
            totalAmount: 0,
            receivedAmount: 0,
            actualAmount: 0,
            shipAmount: 0,
            searchObj: {
                /*q: '',
                effectStartDate: '',
                effectEndDate: '',
                status: '',*/
                cusName: '',  // 客户名称
                payType: '',  // 收款方式
                orderDateStart: '',  // 出库日期（起）
                orderDateEnd: '',  // 出库日期（止）
                totalOrNum: 0,
                // shipTime: {}, // 日期筛选
                s: 10,
                p: 1
            },
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
                searchObj: {
                    // ...this.state.searchObj,
                    /*q: '',
                    effectStartDate: '',
                    effectEndDate: '',
                    status: '',*/
                    cusName: '',  // 客户名称
                    payType: '',  // 收款方式
                    orderDateStart: '',  // 出库日期（起）
                    orderDateEnd: '',  // 出库日期（止）
                    totalOrNum: 0,
                    // shipTime: {}, // 日期筛选
                    s: 10,
                    p: 1
                }, loading: true
            },
            () => {
                this.initData();
                this.setState({filterBoxVisible: !this.state.filterBoxVisible});
            }
        )
        ;
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {  // 查询
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        // const self = this;
        // var sObj = this.state.searchObj;
        // console.log(sObj);
        // sObj.p = 1;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        })
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderDateStart: value.from ? (value.from + ' 00:00:00') : '',
                    orderDateEnd: value.end ? (value.end + ' 23:59:59') : ''
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, () => {
            this.initData();
        })
    }


    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/order/salesQueryListExport?${objectSerial(_searchObj)}`;
        window.open(url);
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
        /* 编辑 */
        this.goView('card/add/' + this.state.rows[index].id);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        var p = this.state.searchObj.p;
        var s = this.state.searchObj.s;
        getSalesQueryList(obj).then(result => {
            if (result && result.status) {
                result.data.map((item, index) => {
                    item.id = index;
                });
                console.log(result);
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    totalAmount: result.dataMap.total || 0,
                    receivedAmount: result.dataMap.received || 0,
                    actualAmount: result.dataMap.actual || 0,
                    shipAmount: result.dataMap.ship || 0,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })

        obj.s = 9999999;
        obj.p = 1;
        getSalesQueryList(obj).then(result => {
            if (result && result.status) {
                this.setState({
                    totalAmount: result.dataMap.total || 0,
                    receivedAmount: result.dataMap.received || 0,
                    actualAmount: result.dataMap.actual || 0,
                    shipAmount: result.dataMap.ship || 0,
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
        obj.s = s;
        obj.p = p;
    }

    componentDidMount() {
        //this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            opts,
            key,
            filterBoxVisible,
            rows,
            total,
            searchObj,
            showHideBtnIndex,
            totalAmount,
            loading,
            receivedAmount,
            actualAmount,
            shipAmount
        } = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'payType',
                    label: '收款方式',
                    text: '选择收款方式',
                    options: [
                        {value: '', text: '全部'},
                        {value: '现金', text: '现金'},
                        {value: '欠款', text: '欠款'},
                        {value: '代收', text: '代收'},
                        {value: '月结', text: '月结'},
                        {value: '银行', text: '银行'},
                        {value: '转账', text: '转账'},
                        {value: '支付宝', text: '支付宝'},
                        {value: '微信', text: '微信'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.payType || ''
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '出库日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.from || '',
                        end: searchObj.end || ''
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '客户名称',
                    dataIndex: 'cusName',
                    // defaultValue: searchObj.cusName
                    // dataIndex: 'name'
                }, {
                    title: '收款方式',
                    dataIndex: 'payType'
                    // dataIndex: 'type'
                }, {
                    title: '面价',
                    dataIndex: 'amount'
                },
                {
                    title: '销售金额',
                    dataIndex: 'receivedAmount'
                }, {
                    title: '实收金额',
                    dataIndex: 'actualAmount'
                }, {
                    title: '发运金额',
                    dataIndex: 'shipAmount'
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
                <p>汇总：面价：{totalAmount} 销售金额：{receivedAmount} 实收金额：{actualAmount} 发运金额：{shipAmount}</p>
            </div>
        </div>
    }
}
;
export default SalesQueryList;
// export default withRouter(SalesQueryList);


// WEBPACK FOOTER //
// ./src/routes/financialMgm/salesQueryList.js